import { Field, FIELD_TYPES, Model } from "../../schema";

export default Model("group_state_model", {
    verbose_name: "Group State Model",
    verbose_name_plural: "Group State Models",
    fields: [
        Field("id", {
            label: "ID",
            primary_key: true,
            readonly: true,
            hide: false,
            field_type: FIELD_TYPES.AutoNumber,
        }),

        Field("base_uri", {
            label: "Base Uri",
            primary_key: false,
            readonly: false,
            hide: false,
            required: false,
            field_type: FIELD_TYPES.String,
            default: () => {
                return null;
            },
        }),
        Field("model_name", {
            label: "Model Name",
            primary_key: false,
            readonly: false,
            hide: false,
            required: false,
            field_type: FIELD_TYPES.String,
            default: () => {
                return null;
            },
        }),
        Field("fields", {
            label: "Fields",
            primary_key: false,
            readonly: false,
            hide: false,
            required: false,
            field_type: FIELD_TYPES.ManyToMany,
            ref_field_type: "GroupStateModelField",
            default: () => {
                return [];
            },
        }),
    ],
});
